"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledChildrenWrapper = exports.StyledMenuItemIconWrapper = exports.StyledMenuItem = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

var _spacing = require("../../system/spacing.style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  text-align: center;\n  @media screen and (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  margin: 0 0.5em;\n  min-width: 1rem;\n  svg {\n    ", ":hover & {\n      fill: #4ba1e9;\n    }\n  }\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  ", "\n  ", "\n  color: ", ";\n  background-color: ", ";\n  overflow: hidden;\n  margin: 0 1px 1px 0;\n  @media screen and (min-width: ", ") {\n    padding: 1em;\n    width: 1.1em;\n  }\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    :hover {\n      background-color: ", ";\n      color: ", ";\n      cursor: pointer;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var hoverStyle = function hoverStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), (0, _colors.normaliseColor)(props.theme.menuItem.hoverBackgroundColor, props.theme), (0, _colors.normaliseColor)(props.theme.menuItem.hoverTextColor, props.theme));
};

var selectedStyle = function selectedStyle(props) {
  return (0, _styledComponents.css)(_templateObject2(), (0, _colors.normaliseColor)(props.theme.menuItem.selectedBackgroundColor, props.theme), (0, _colors.normaliseColor)(props.theme.menuItem.selectedTextColor, props.theme), (0, _colors.normaliseColor)(props.theme.menuItem.selectedTextColor, props.theme));
};

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject3(), props.disabled && "opacity: 0.3;");
};

var StyledMenuItem = _styledComponents.default.li(_templateObject4(), function (props) {
  return props.theme.menuItem.padding;
}, function (props) {
  return (0, _spacing.spacingStyle)(props.theme, props.padding, props.inset);
}, function (props) {
  return props.hasIcon && "";
}, function (props) {
  return props.color || (0, _colors.normaliseColor)(props.theme.menuItem.textColor, props.theme);
}, function (props) {
  return props.backgroundColor || (0, _colors.normaliseColor)(props.theme.menuItem.backgroundColor, props.theme);
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.md;
}, function (props) {
  return props.selected && selectedStyle(props);
}, function (props) {
  return props.disabled && disabledStyle(props);
}, function (props) {
  return !props.disabled && hoverStyle(props);
});

exports.StyledMenuItem = StyledMenuItem;

var StyledMenuItemIconWrapper = _styledComponents.default.div(_templateObject5(), StyledMenuItem, function (props) {
  return props.selected && selectedStyle(props);
});

exports.StyledMenuItemIconWrapper = StyledMenuItemIconWrapper;

var StyledChildrenWrapper = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.md;
});

exports.StyledChildrenWrapper = StyledChildrenWrapper;